<template>
  <v-tooltip
    v-if="avatarOnly"
    bottom
  >
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <p-avatar
          :color="value.color"
          :email="value.email"
          :char="value.fullName[0]"
          :class="avatarClass"
        ></p-avatar>
      </span>
    </template>
    {{ fullName }} <span v-if="!value.isActive">{{ $t('components.userItem.inactive') }}</span>
  </v-tooltip>

  <v-list-item v-else class="px-0">
    <p-avatar
      :color="value.color"
      :email="value.email"
      :char="value.fullName[0]"
      :class="avatarClass"
      list-item-avatar
    ></p-avatar>
    <v-list-item-content
      :class="{ 'font-weight-medium': fontBold }"
    >
      {{ fullName }} <span v-if="!value.isActive">{{ $t('components.userItem.inactive') }}</span>
    </v-list-item-content>
  </v-list-item>
</template>


<script>
import { mapGetters } from 'vuex'

import PAvatar from '@/components/PAvatar'


export default {
  components: {
    PAvatar
  },


  props: {
    value: {
      type: Object,
      required: true
    },
    fontBold: {
      type: Boolean,
      default: false
    },
    you: {
      type: Boolean,
      default: false
    },
    avatarOnly: {
      type: Boolean,
      default: false
    },
    avatarClass: {
      type: String
    }
  },


  computed: {
    ...mapGetters('user', ['currentUserId', 'currentUser']),

    fullName () {
      let name = this.value.fullName

      if (this.you && this.value.id === this.currentUser.id) {
        name += ' ' + this.$t('user.you')
      }

      return name
    }
  }
}
</script>
